<div class="ticket-message main-message">
    <div
        class="d-flex flex-row justify-content-start"
        [ngClass]="{
            'align-items-start': ticket.source === ticketSourceEnum.email || ticket.source === ticketSourceEnum.form,
            'align-items-center': ticket.source !== ticketSourceEnum.email && ticket.source !== ticketSourceEnum.form,
            'one-time': commonDataService.isOneTime,
        }">
        @if (ticket.firstMessageCreator) {
            <sb-user-avatar
                class="pointer"
                (click)="rightPanelService.open(rightPanelTypeEnum.user, { user: ticket.firstMessageCreator })"
                [user]="ticket.firstMessageCreator"
                [isNeedTooltip]="false"
                [withRoleTooltip]="true">
            </sb-user-avatar>
        }
        <div>
            <div class="right-angle-info-container">
                <a
                    class="user-name text-break"
                    (click)="rightPanelService.open(rightPanelTypeEnum.user, { user: ticket.firstMessageCreator })">
                    {{ ticket.firstMessageCreator.name || ticket.firstMessageCreator.email }}
                    @if (
                        ticket.source === ticketSourceEnum.instagram &&
                        ticket.firstMessageCreator.socialMediaAccountInfo?.accountName
                    ) {
                        <span>&nbsp;(&#64;{{ ticket.firstMessageCreator.socialMediaAccountInfo?.accountName }})</span>
                    }
                </a>
                <span class="right-angle-info">
                    @if (ticket.source === ticketSourceEnum.email || ticket.source === ticketSourceEnum.form) {
                        <small class="text-light">
                            {{ ticket.firstMessageCreationTime | ticketEmailTime }}
                        </small>
                    } @else {
                        <small
                            class="text-light"
                            tooltip="{{ ticket.firstMessageCreationTime | date: 'dd.MM.yyyy HH:mm' }}">
                            {{ ticket.firstMessageCreationTime | timeAgo }}
                        </small>
                    }

                    @if (
                        !commonDataService.isOneTime &&
                        !commonDataService.user.isReadOnly &&
                        !ticket.isFirstMessageDeleted &&
                        (ticket.constraints?.isContentHidingAllowed ||
                            isInboxElementVisible(
                                commonDataService.customerSettings?.inboxElementsVisibility?.ticketHeader?.forwardAction
                            ))
                    ) {
                        <span class="reply-menu position-static" dropdown placement="bottom right">
                            <button
                                class="btn btn-icon btn-transparent print-hidden"
                                data-testid="main-message-actions-menu"
                                dropdownToggle
                                type="button"
                                aria-controls="dropdown-basic">
                                <sb-inline-svg
                                    class="icon"
                                    aria-label="My icon"
                                    [url]="
                                        '/sb-tools/theme/images/Svg icons WEB/Web icons/More icon.svg'
                                    "></sb-inline-svg>
                            </button>

                            <ul
                                id="dropdown-basic"
                                *dropdownMenu
                                class="dropdown-menu dropdown-menu-right"
                                role="menu"
                                aria-labelledby="button-basic">
                                @if (
                                    isInboxElementVisible(
                                        commonDataService.customerSettings?.inboxElementsVisibility?.ticketHeader
                                            ?.forwardAction
                                    )
                                ) {
                                    <li role="menuitem">
                                        <button
                                            class="dropdown-item"
                                            data-testid="forward-message-action"
                                            type="button"
                                            (click)="
                                                forwardMessageService.openForwardForm(
                                                    {
                                                        ticketId: ticket.id,
                                                        id: ticket.id,
                                                        message: ticket.message,
                                                        attachments: ticket.attachments,
                                                    },
                                                    forwardEntityTypeEnum.ticketMessage,
                                                    ticket
                                                )
                                            "
                                            translate>
                                            Forward message
                                        </button>
                                    </li>
                                }
                                @if (ticket.constraints.isContentHidingAllowed) {
                                    @if (!ticket.isContentHiddenForClient) {
                                        <li role="menuitem">
                                            <button
                                                class="dropdown-item"
                                                type="button"
                                                (click)="openHideContentPanel()"
                                                translate>
                                                Hide content
                                            </button>
                                        </li>
                                    }
                                    @if (ticket.isContentHiddenForClient || ticket.hasContentPartHiddenForClient) {
                                        <li role="menuitem">
                                            <button
                                                class="dropdown-item"
                                                type="button"
                                                (click)="deleteHiddenContent()"
                                                translate>
                                                Restore hidden content
                                            </button>
                                        </li>
                                    }
                                }
                            </ul>
                        </span>
                    }
                </span>
                <div>
                    <!--                    todo: move to separated component?-->
                    @if (ticket.starRating) {
                        @if (ticket.starRating && ticket.source !== ticketSourceEnum.trustpilot) {
                            @for (rateValue of [1, 2, 3, 4, 5]; track rateValue) {
                                <sb-inline-svg
                                    class="icon icon-star"
                                    [ngClass]="{ 'icon-star-colored': ticket.starRating >= rateValue }"
                                    aria-label="My icon"
                                    [url]="'/sb-tools/theme/images/icons/Star filled.svg'"></sb-inline-svg>
                            }
                        }

                        @if (ticket.source === ticketSourceEnum.trustpilot) {
                            <div class="trustpilot-rating">
                                <sb-inline-svg
                                    [url]="
                                        'assets/images/trustpilot/stars-' + ticket.starRating + '.svg'
                                    "></sb-inline-svg>
                            </div>
                        }
                    }
                </div>
            </div>
            @if (
                (ticket.source === ticketSourceEnum.email || ticket.source === ticketSourceEnum.form) &&
                !isToAndCcHidden &&
                ticket.emailInfo
            ) {
                <div class="text-emails text-light">
                    {{ 'To:' | translate }}
                    {{ ticket.emailInfo.to | join }}
                    <button
                        class="btn btn-icon"
                        [popover]="emailEnvelopeTemplate"
                        [outsideClick]="true"
                        tooltip="{{ 'Show details' | translate }}">
                        <span class="add-arrow"></span>
                    </button>
                    <ng-template #emailEnvelopeTemplate>
                        <div>
                            <div>
                                <span class="email-info-title" translate>From:</span>
                                <span class="email-info-content">
                                    <strong>{{ ticket.emailInfo.fromName }}</strong>
                                    @if (ticket.emailInfo.fromAddress) {
                                        <span> &nbsp;&lt;{{ ticket.emailInfo.fromAddress }}&gt; </span>
                                    }
                                </span>
                            </div>
                            <div>
                                <span class="email-info-title" translate>To:</span>
                                <span class="email-info-content">
                                    {{ ticket.emailInfo.to | join }}
                                </span>
                            </div>
                            <div>
                                <span class="email-info-title" translate>Resent-From:</span>
                                <span class="email-info-content">
                                    {{ ticket.emailInfo.resentFrom }}
                                </span>
                            </div>
                            <div>
                                <span class="email-info-title" translate>Cc:</span>
                                <span class="email-info-content">{{ ticket.emailInfo.cc | join }} </span>
                            </div>
                            @if (ticket.emailInfo.bcc?.length) {
                                <div>
                                    <span class="email-info-title" translate>Bcc:</span>
                                    <span class="email-info-content">{{ ticket.emailInfo.bcc | join }}</span>
                                </div>
                            }
                            <div>
                                <span class="email-info-title" translate>Date:</span>
                                <span class="email-info-content">
                                    {{ ticket.emailInfo.date | date: 'dd.MM.yyyy HH:mm' }}</span
                                >
                            </div>
                            <div>
                                <span class="email-info-title" translate>Subject:</span>
                                <span class="email-info-content">{{ ticket.emailInfo.subject }}</span>
                            </div>
                        </div>
                    </ng-template>
                </div>
            }
        </div>
    </div>
    <div class="message-body message-body-email">
        <hr />

        @if (ticket.sharedLink) {
            <div class="bottom10">
                <a [href]="ticket.sharedLink" target="_blank">{{ ticket.sharedLink }}</a>
            </div>
        }

        @if (ticket.phoneNumber && ticket.phoneNumber !== 'na') {
            <div>
                <a href="tel:{{ ticket.phoneNumber }}">
                    <sb-inline-svg
                        class="icon me-1"
                        aria-label="My icon"
                        [url]="'/assets/images/phone.svg'"></sb-inline-svg>
                    <span class="vertical-align-middle">{{ ticket.phoneNumber }}</span>
                </a>
            </div>
        }

        @if (!ticket.isFirstMessageDeleted) {
            <div
                class="break-word message-html-content"
                sbInlineImagePreview
                appInlineImageLimitWidth
                [ngClass]="{ 'sb-hidden-content-part': ticket.isContentHiddenForClient }"
                [innerHTML]="
                    ticket.message
                        | hideContent
                        | prepareMessage
                        | replaceEmojis
                            : ticket.source === this.ticketSourceEnum.email ||
                                  ticket.source === this.ticketSourceEnum.form
                "></div>
            @if (ticket.isEdited) {
                <small class="text-light">({{ 'edited' | translate }})</small>
            }
        } @else {
            <small class="text-light" translate>This post was deleted.</small>
        }

        @if (ticket.hasOriginalMessage) {
            <div class="original-message">
                <a (click)="showOriginalMessage(ticket.id)">
                    <small><span translate>Show original message</span></small>
                </a>
            </div>
        }

        @if (ticket.fields?.length) {
            <app-fields [ticket]="ticket"></app-fields>
        }

        <div class="file-view-container">
            @for (attachment of ticket.contentAttachments; track attachment) {
                <sb-file-view
                    [isRoundedCorners]="false"
                    [isFullWidthView]="true"
                    [isFilePreviewInModal]="true"
                    [permalink]="ticket.permalink"
                    [attachment]="attachment"
                    [attachments]="ticket.contentAttachments"
                    [canBeShared]="
                        !commonDataService.isOneTime &&
                        !commonDataService.user.isReadOnly &&
                        isInboxElementVisible(
                            commonDataService.customerSettings?.inboxElementsVisibility?.ticketHeader?.forwardAction
                        )
                    "
                    [reply]="{
                        author: ticket.firstMessageCreator,
                        creationTime: ticket.firstMessageCreationTime,
                    }"
                    (forwardFile)="
                        forwardMessageService.openForwardForm(
                            { message: {}, attachments: [$event] },
                            forwardEntityTypeEnum.attachment,
                            ticket
                        )
                    ">
                </sb-file-view>
            }
        </div>

        @if (ticket.notContentAttachments.length) {
            <div>
                <hr />
                <span>
                    <span class="icon me-2">
                        <sb-inline-svg
                            class="icon"
                            aria-label="My icon"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Attachment icon.svg'">
                        </sb-inline-svg> </span
                    >{{ ticket.attachments.length }}
                </span>

                <div class="attachments-block">
                    @for (attachment of ticket.notContentAttachments; track attachment; let idx = $index) {
                        <sb-file-preview
                            class="file-container"
                            [permalink]="ticket.permalink"
                            [attachments]="ticket.notContentAttachments"
                            [attachment]="attachment"
                            [fileIndex]="idx"
                            [reply]="{
                                author: ticket.firstMessageCreator,
                                creationTime: ticket.firstMessageCreationTime,
                            }"
                            [canBeShared]="
                                !commonDataService.isOneTime &&
                                !commonDataService.user.isReadOnly &&
                                isInboxElementVisible(
                                    commonDataService.customerSettings?.inboxElementsVisibility?.ticketHeader
                                        ?.forwardAction
                                )
                            "
                            (forwardFile)="
                                forwardMessageService.openForwardForm(
                                    { message: {}, attachments: [$event] },
                                    forwardEntityTypeEnum.attachment,
                                    ticket
                                )
                            ">
                        </sb-file-preview>
                    }
                    <div class="clearfix"></div>
                </div>
                <div class="clearfix"></div>
            </div>
        }

        <app-integration-block class="integration-block print-hidden" [ticket]="ticket"></app-integration-block>
    </div>
</div>
